import React from "react";
import { Link } from "react-router-dom";
import { Container } from "react-bootstrap";
import Layout from "../../layout/Layout";

const FAQ = (props: any) => {
  return (
    <Layout>
      <div className={localStorage.length ? "" : "charity_publicBox"}>
        <Container>
          <div className="text-light">
            <div className="faqMainContent">
              <div className="heading"><h2>Frequently Asked Questions</h2></div>
              <p>BeyondBox is more than an app. It’s a platform for intentional living and meaningful legacy creation. Whether you’re capturing life’s most precious moments, reflecting on what matters most, planning for the future, or sharing heartfelt messages, BeyondBox empowers you to create a profound and lasting impact on the people you love.</p>
              <p>Your BeyondBox Life Space is designed to help you live with greater intention today while preserving your story, wisdom, memories, and love for tomorrow.</p>
              <p>Below, we’ve answered some of the most frequently asked questions from our users. If you require additional assistance, please don’t hesitate to contact us through our Contact Us page.</p>
              <p>
                <h4 className="text-warning">Why BeyondBox?</h4>
                <p>BeyondBox is designed to help you live fully and leave meaningfully. It’s a space to preserve your love, wisdom, memories, and reflections while encouraging you to live with greater purpose each day.</p>
                <p>From setting goals and practicing gratitude to leaving messages of comfort and guidance for loved ones, BeyondBox helps you create a lasting legacy that can resonate for generations. Each Legacy Box you create carries immeasurable emotional value for the people fortunate enough to receive one.</p>
              </p>
              <p>
              <h4 className="text-warning">Who can benefit from BeyondBox?</h4>
              BeyondBox is for anyone who:
              <ul style={{listStyleType:"disc"}}>
                    <li>Wants to preserve their life story, values, memories, and reflections for loved ones</li>
                    <li>Wishes to leave a meaningful impact on family and friends after their passing.</li>
                    <li>Values intentional living, self-reflection, and goal setting through tools like the Vision Box and Reflect Box.</li>
                    <li>Seeks a secure and trusted space to preserve and share meaningful content and messages.</li>
                </ul>
              </p>
              <p>
              <h4 className="text-warning">How does BeyondBox support intentional living?</h4>
              BeyondBox is designed not only to help you preserve your legacy, but also to help you engage more intentionally with your life in the present. Features such as the Vision Box and Reflect Box encourage users to reflect on their goals, gratitude, values, growth, and aspirations, helping cultivate greater mindfulness, purpose, and appreciation for life.
              </p>
              <p>
              <h4 className="text-warning">How does BeyondBox handle grief support?</h4>
              BeyondBox provides a deeply personal source of comfort by delivering heartfelt messages, wisdom, memories, and reflections to your loved ones after your passing. Legacy Boxes can help recipients feel connected to your presence, guidance, and love during their lives, creating a lasting sense of emotional connection and support.
              </p>
              <p>
              <h4 className="text-warning">Does BeyondBox have a Free Plan?</h4>
              Yes. You can sign up for the BeyondBox Free Plan at no cost.
              <ul style={{listStyleType:"disc"}}>
                    <li>The Free Plan allows you to create one Legacy Box with one recipient and includes 50MB of storage for media such as text messages, photos, videos, audio messages, and documents.</li>
                    <li>You may also create one Public Box Profile to preserve your life’s story for future generations to discover.</li>
                    <li>To unlock the full Life Space experience and all premium features, you can upgrade to the BeyondBox Premium Plan.</li>
                </ul>
              </p>
              <p>
              <h4 className="text-warning">What are the features of the Premium Plan?</h4>
              With a BeyondBox Premium Plan, you gain access to the full BeyondBox Life Space experience. Premium features include:
                <ul style={{listStyleType:"disc"}}>
                    <li>Unlimited box creation and receiving.</li>
                    <li>Support for video, audio, images, documents, and text content.</li>
                    <li>Total storage of 3GB with the option to expand storage if needed.</li>
                    <li>Up to five recipients per box.</li>
                    <li>Access to all box types, including the Beyond Box, Vision Box, Reflect Box, Family Box, Public Box, and Info Box.</li>
                    <li>Permanent access to received boxes.</li>
                    <li>The ability to downgrade to the Free Plan at any time.</li>
                    <li>Additionally, 10% of BeyondBox profits are allocated toward the BeyondBox Foundation in support of charitable initiatives and humanitarian causes.</li>
                </ul>
              </p>
              <p>
              <h4 className="text-warning">What are the different types of boxes that I can create with a Premium subscription?</h4>
              BeyondBox offers several types of boxes designed to guide meaningful reflection, intentional living, and legacy creation:
              </p>
              <p>
              <h4 className="text-warning">BeyondBox</h4>
              Your personal legacy space where you can leave heartfelt messages, guidance, memories, videos, audio, and reflections for loved ones to receive after your passing.
              </p>
              <p>
              <h4 className="text-warning">Info-Box</h4>
              A practical way to guide loved ones with important non-sensitive information such as advisor details, estate contacts, will locations, and final wishes.
              </p>
              <p>
              <h4 className="text-warning">Family-Box</h4>
              Preserve your family’s history, traditions, stories, values, and treasured moments for future generations.
              </p>
              <p>
                <h4 className="text-warning">Public-Box</h4>
                Share a final public message, story, or reflection with the world. Public Boxes will be featured on our Box Records page and social platforms to honour and celebrate your life.
              </p>
              <p>
                <h4 className="text-warning">Vision-Box</h4>
                A space dedicated to your goals, dreams, aspirations, and future plans. Use it to reflect on your direction and create an inspiring blueprint for your future.
              </p>
              <p>
                <h4 className="text-warning">Reflect-Box</h4>
                A daily reflection space designed to encourage gratitude, mindfulness, intentional living, and personal growth. Capture life’s highlights, reflections, and intentions for the days ahead.
              </p>
              <p>
                <h4 className="text-warning">Tell me more about the BeyondBox Foundation?</h4>
                The BeyondBox Foundation is the philanthropic arm of the BeyondBox platform. 10% of BeyondBox profits are allocated toward supporting charitable initiatives and organizations aligned with our mission of compassion, human connection, and meaningful impact.
              </p>
              <p>
                <h4 className="text-warning">Are the boxes I create encrypted and secure?</h4>
                <p>Yes. All boxes are end-to-end encrypted, meaning only you and your intended recipients can access the content within them.</p>
                <p>The security of your content is extremely important to us. BeyondBox utilizes AWS infrastructure, SSL encryption, and multi-factor authentication options to help ensure that your Life Space and Legacy Boxes remain secure and protected.</p>
              </p>
              <p>
                <h4 className="text-warning">What is the Safe Space Philosophy?</h4>
                <p>Our Safe Space Philosophy is a unique approach to digital trust and security.</p>
                <p>We encourage users to avoid storing highly sensitive information and instead focus on preserving meaningful, non-sensitive content such as memories, reflections, messages, goals, wisdom, and life experiences.</p>
                Examples of content we discourage storing include:
                <ul style={{listStyleType:"disc"}}>
                    <li>Financial account numbers</li>
                    <li>Passwords or security keys</li>
                    <li>Confidential business information</li>
                    <li>Identity or passport documents</li>
                    <li>Sensitive legal or confidential records</li>
                </ul>
                This philosophy, combined with robust security measures, helps create a trusted and emotionally safe environment for intentional living and legacy preservation.
              </p>
              <p>
                <h4 className="text-warning">Is there a BeyondBox mobile app?</h4>
                <p>Yes. BeyondBox is available via our mobile app on the Apple App Store and Google Play Store.</p>
                <p>The app allows you to build and manage your Life Space conveniently and privately from anywhere. You can upload or record photos, videos, audio messages, reflections, notes, and documents directly from your mobile device.</p>
                <p>You can also access received Legacy Boxes, manage recipients, and update your account settings.</p>
              </p>
              <p>
              <h4 className="text-warning">How do I create a box and add recipients?</h4>
              Creating a box is simple:
              <ol>
                    <li>Sign in to your account via the BeyondBox mobile app</li>
                    <li>Navigate to the “My Boxes” page</li>
                    <li>Select “Add Box”</li>
                    <li>Choose a box cover, name, and description</li>
                    <li>Add recipients (up to 5 on Premium Plans)</li>
                    <li>Save your box and begin adding meaningful content</li>
                </ol>
              </p>
              <p>
              <h4 className="text-warning">What information will I need to add a recipient?</h4>
              You will need the recipient’s:
                <ul style={{listStyleType:"disc"}}>
                  <li>Name</li>
                  <li>Surname</li>
                  <li>Email address</li>
                  <li>Date of birth</li>
                  <li>Relationship to you</li>
                </ul>
              </p>
              <p>
              <h4 className="text-warning">Can I leave a box to someone under the age of 18?</h4>
              Yes. In this case, you should use the email address of the child’s parent or legal guardian, who will manage access to the Legacy Box on behalf of the child.
              </p>
              <p>
              <h4 className="text-warning">How will the BeyondBox team be notified of my passing?</h4>
                <p>When creating your profile, you will nominate a Trustee or Next of Kin.</p>
                <p>This trusted individual should notify BeyondBox of your passing and provide a valid government-issued Notice of Death so we can verify and activate the release of your Legacy Boxes.</p>
              </p>
              <p>
              <h4 className="text-warning">When will recipients be notified that I left them a Legacy Box?</h4>
                <p>Recipients will only be notified after your passing has been officially verified through your Trustee or Next of Kin.</p>
                <p>At that point, they will receive instructions on how to securely access their Legacy Box.</p>
              </p>
              <p>
              <h4 className="text-warning">Does a recipient need a paid plan to receive a Legacy Box?</h4>
              <p>No. Recipients can create a free BeyondBox account to access Legacy Boxes shared with them.</p>
              <p>Received boxes remain accessible for 12 months on the Free Plan.</p>
              </p>
              <p>
              <h4 className="text-warning">Can I schedule the release of content?</h4>
              Yes. Individual pieces of content within a Legacy Box can be scheduled for release for up to 10 years after your passing.
              </p>
              <p>
              <h4 className="text-warning">Can I make changes to a box after it has been created?</h4>
              Yes. You may edit your boxes at any time, including the cover image, recipients, title, description, and content.
              </p>
              <p>
              <h4 className="text-warning">Can I delete items in a box?</h4>
              Yes. Deleted items remain in your Recycle Bin for 30 days, allowing you to restore them if needed during that time.
              </p>
              <p>
              <h4 className="text-warning">Why does BeyondBox have a Suicide Exclusion?</h4>
                <p>All users are required to accept a Suicide Exclusion when joining BeyondBox.</p>
                <p>This policy states that if a user’s death is determined to be due to suicide, their Legacy Boxes will not be released.</p>
                <p>This exists because we never want BeyondBox to become a platform associated with suicide notes or discourage individuals from seeking support during difficult times.</p>
                <p>BeyondBox is built around the belief in the value, meaning, and preciousness of life. While we encourage thoughtful life and legacy planning, we are equally committed to promoting hope, reflection, healing, and human connection.</p>
              </p>
              <h4 className="text-warning">How can you contact us?</h4>
              <p>
                <strong>Email: &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</strong> info@beyondbox.org<br />
                <strong>Web: &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</strong> <Link to="/">www.beyondbox.org</Link><br />
                <strong>WhatsApp: &nbsp;</strong> (+27)78 479 0054<br/>
                {/* <Link to="/contact_us">Contact Us Page</Link> */}
              </p>
            </div>
          </div>
        </Container>
      </div>
    </Layout>
  );
};

export default FAQ;